<template>
  <div id="data-container">
    <div id="images-container">
      <div id="elev">
        <img :src="elevUrl" />
      </div>
      <v-card class="mx-auto">
        <v-img height="300px" :src="bestUrl">
          <v-card-title>MOST OPTIMAL VIEW</v-card-title>
        </v-img>
      </v-card>
      <v-card>
        <v-img height="300px" :src="worstUrl">
          <v-card-title>LEAST OPTIMAL VIEW</v-card-title>
        </v-img>
      </v-card>
    </div>
    <div id="site-plan">
      <img :src="sitePlanUrl" />
    </div>
    <div id="score-container">
      <div id="individual-score">
        <label>UNIT AVERAGE SCORE</label>
        <h1 id="score">{{ score }}%</h1>
      </div>
      <div id="total-score">
        <label>SITE AVERAGE SCORE</label>
        <h1 id="total">{{ total }}%</h1>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    worstUrl: String,
    bestUrl: String,
    score: Number,
    total: Number,
    elevUrl: String,
    sitePlanUrl: String,
  },
};
</script>

<style>
@import "../assets/css/structure.css";
@import "../assets/css/style.css";
</style>
